<template>
  <div class="mains">
    <div class="campus">
      学生测试
      <span>></span>
      规则管理
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">规则管理</div>
            <div class="xiaoqu_2">
              <div @click="changeSeries">
                <div class="icon_change"></div>
                切换系列
              </div>

            </div>
            <el-dialog title="选择系列" :visible.sync="dialogFormVisible4">
              <el-form>
                <el-form-item label="小程序名称" :label-width="formLabelWidth">
                  <el-select v-model="appletList" placeholder="请选择小程序" @change="changeDisabled()">
                    <el-option v-for="item in xcxList" :value="item.id" :label="item.name" :key="item.id" @click.native="miniid=item.id">{{item.name}}</el-option>
                  </el-select>
                </el-form-item>
                <i>
                  <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                </i>
                <el-form-item label="系列名称" :label-width="formLabelWidth">
                  <el-select v-model="bookSeries" placeholder="请选择系列" :disabled="disabled" @visible-change="referOrganzationList()">
                    <el-option v-for="item in bookList" :value="item.name" :key="item.id" @click.native="groupId=item.groupid">{{item.name}}</el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit();dialogFormVisible4 = false">确 定</el-button>
                <el-button @click="dialogFormVisible4 = false">取 消</el-button>
              </div>
            </el-dialog>
          </div>
          <el-button type="primary" @click="dialogFormVisible = true" v-show="newLevel">+ 新建等级</el-button>
          <!-- <el-button type="primary" @click=" dialogFormVisible3 = true" v-show="addLevel">+ 增加等级</el-button> -->
          <el-dialog title="新建规则" :visible.sync="dialogFormVisible">
            <el-form>
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-form-item label="规则名称" :label-width="formLabelWidth" style="color:#cccccc">
                <el-input v-model="inputrule" autocomplete="off" placeholder="请输入您要新建的等级数量"></el-input>
                <span class="hint">（ 注：您在输入框内输入新建等级数量后，系统将自动为您新建该数量的连续等级；
                  按钮将变换为“增加等级”，功能原理同“新建等级”相同 ）</span>
              </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="readGrade();dialogFormVisible = false">确 定</el-button>
              <el-button @click="dialogFormVisible = false">取 消</el-button>
            </div>
          </el-dialog>
          <el-dialog title="新建规则" :visible.sync="dialogFormVisible3">
            <el-form>
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-form-item label="规则名称" :label-width="formLabelWidth" style="color:#cccccc">
                <el-input v-model="inputrule" autocomplete="off" placeholder="请输入您要新建的等级数量"></el-input>
                <span class="hint">（ 注：您在输入框内输入新建等级数量后，系统将自动为您新建该数量的连续等级；
                  按钮将变换为“增加等级”，功能原理同“新建等级”相同 ）</span>
              </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="readGrade();dialogFormVisible3 = false">确 定</el-button>
              <el-button @click="dialogFormVisible3 = false">取 消</el-button>
            </div>
          </el-dialog>
          <span class="hint">注：此部分是您建立学生测试的整体等级，点击“新建等级”按钮后输入您所要新建连续等级的数量，将为您新建该数量的连续等级；</span>
          <!-- 112112 -->
          <div class="zsbg">
            <el-table :data="form" border style="width: 100%">
              <el-table-column prop="levelName" label="等级名称" max-width="360">

              </el-table-column>

              <el-table-column prop="createDate" label="创建时间"></el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <!--<el-button type="text">APP下载页</el-button>-->
                  <el-button type="text" @click="lookrule()">查看等级试题</el-button>
                  <el-button type="text" @click="removerule(scope.row.id)">删除等级</el-button>

                </template>
              </el-table-column>
            </el-table>

          </div>
          <div class="fenye">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </el-card>

      <div class="bottom-card">
        <div class="bottom-card-left">
          <el-card>
            <div class="grid-content">
              <div class="rule">
                <div class="xiaoqu_1">初级规则</div>
              </div>
              <div class="btn-hint">

                <el-button type="primary" @click="dialogFormVisible1 = true">+ 新建学习时长</el-button>
                <el-dialog title="新建学习时长" :visible.sync="dialogFormVisible1">
                  <el-form>
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                    </i>
                    <el-form-item label="学习时长" :label-width="formLabelWidth">

                      <el-select v-model="region" placeholder="请选择学习时长">
                        <el-option label="0 year" value="0"></el-option>
                        <el-option label="1 year" value="1"></el-option>
                        <el-option label="2 years" value="2"></el-option>
                        <el-option label="3 years" value="3"></el-option>
                        <el-option label="4 years" value="4"></el-option>
                      </el-select>
                      <el-select v-model="region1" placeholder="请选择学习时长">
                        <el-option label="0 month" value="0"></el-option>
                        <el-option label="1 month" value="1"></el-option>
                        <el-option label="2 months" value="2"></el-option>
                        <el-option label="3 months" value="3"></el-option>
                        <el-option label="4 months" value="4"></el-option>
                        <el-option label="5 months" value="5"></el-option>
                        <el-option label="6 months" value="6"></el-option>
                        <el-option label="7 months" value="7"></el-option>
                        <el-option label="8 months" value="8"></el-option>
                        <el-option label="9 months" value="9"></el-option>
                        <el-option label="10 months" value="10"></el-option>
                        <el-option label="11 months" value="11"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addLearnTime();dialogFormVisible1 = false">确 定</el-button>
                    <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                  </div>
                </el-dialog>
                <span class="hint">注：此部分是初级规则，为学生在输入“学习英语时长”后，根据您所制定的“初级规则”为学生匹配
                  相应的等级测试一</span>
              </div>

              <div class="zsbg">
                <el-table :data="form1" border style="width: 100%" class="zsbg_table1">
                  <el-table-column prop="learnTimeStr" label="学习时长">
                  </el-table-column>
                  <el-table-column prop="chooseLevel" label="匹配等级">
                    <template slot-scope="scope">
                      <el-button type="text" @click="dialogFormVisible5 = true" v-show="xuanzedengji">选择等级</el-button>
                      <div>{{scope.row.levelName}}</div>
                    </template>

                  </el-table-column>

                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="changeTimeLevel(scope.row) ">修改等级</el-button>
                      <el-button type="text" @click="editLearnTime(scope.row)">编辑时长</el-button>
                      <el-dialog title="编辑学习时长" :visible.sync="dialogFormVisible7">

                        <el-form>
                          <i>
                            <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                          </i>
                          <el-form-item label="学习时长" :label-width="formLabelWidth">

                            <el-select v-model="region" placeholder="请选择学习时长">
                              <el-option label="0 year" value="0"></el-option>
                              <el-option label="1 year" value="1"></el-option>
                              <el-option label="2 years" value="2"></el-option>
                              <el-option label="3 years" value="3"></el-option>
                              <el-option label="4 years" value="4"></el-option>
                            </el-select>
                            <el-select v-model="region1" placeholder="请选择学习时长">
                              <el-option label="0 month" value="0"></el-option>
                              <el-option label="1 month" value="1"></el-option>
                              <el-option label="2 months" value="2"></el-option>
                              <el-option label="3 months" value="3"></el-option>
                              <el-option label="4 months" value="4"></el-option>
                              <el-option label="5 months" value="5"></el-option>
                              <el-option label="6 months" value="6"></el-option>
                              <el-option label="7 months" value="7"></el-option>
                              <el-option label="8 months" value="8"></el-option>
                              <el-option label="9 months" value="9"></el-option>
                              <el-option label="10 months" value="10"></el-option>
                              <el-option label="11 months" value="11"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                          <el-button type="primary" @click="updateTime()">确 定</el-button>
                          <el-button @click="dialogFormVisible7 = false">取 消</el-button>
                        </div>
                      </el-dialog>
                      <el-button type="text" @click="deleteTime(scope.row.id)">删除</el-button>
                      <!-- {{scope.row}} -->
                    </template>

                  </el-table-column>

                </el-table>
              </div>
              <div class="fenye-bottom_left">
                <el-pagination background @size-change="lookLearnTime" @current-change="handleCurrentChangess" :current-page.sync="currentPagess" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSizess"
                  layout="total, sizes, prev, pager, next, jumper" :total="totalss"></el-pagination>
              </div>

            </div>
          </el-card>
        </div>
        <div class="bottom-card-right">
          <el-card>
            <div class="grid-content">
              <div class="rule">
                <div class="xiaoqu_1">进阶规则</div>
              </div>
              <div class="btn-hint">
                <el-button type="primary" @click="dialogFormVisible2 = true">+ 新建测试得分 </el-button>
                <el-dialog title="新建规则管理" :visible.sync="dialogFormVisible2">
                  <el-form>
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                    </i>
                    <el-form-item label="活动区域" :label-width="formLabelWidth">
                      <el-input class="scroeStart" v-model="input" placeholder="请输入内容"></el-input>

                      <el-input class="scroeEnd" v-model="input1" placeholder="请输入内容"></el-input>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addTestRule();dialogFormVisible2 = false">确 定</el-button>
                    <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                  </div>
                </el-dialog>
                <el-dialog title="新建规则管理" :visible.sync="dialogFormVisible8">
                  <el-form>
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                    </i>
                    <el-form-item label="活动区域" :label-width="formLabelWidth">
                      <el-input class="scroeStart" v-model="input" placeholder="请输入内容"></el-input>

                      <el-input class="scroeEnd" v-model="input1" placeholder="请输入内容"></el-input>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="editForwordrule();dialogFormVisible8 = false">确 定</el-button>
                    <el-button @click="dialogFormVisible8 = false">取 消</el-button>
                  </div>
                </el-dialog>
                <span class="hint">注：此部分是进阶规则，在学生测试一完成后，根据测试得分进行下一测试等级的增减，同样适应
                  于测试二的匹配规则</span>
              </div>
              <div class="zsbg">
                <el-table :data="form4" border style="width: 100%" class="zsbg_table1">
                  <el-table-column prop="scoreTop" label="测试得分">
                    <template slot-scope="{row}">
                      {{row.scoreBottom}}——{{row.scoreTop}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="ruleStr" label="增减等级">

                  </el-table-column>

                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="lookThisRule(scope.row.id)">修改等级</el-button>
                      <el-button type="text" @click="lookEdiltRule(scope.row.id)">编辑得分</el-button>
                      <el-button type="text" @click="deleteForword(scope.row.id)">删除等级</el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
              <div class="fenye-bottom_right">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-.sync="currentPages" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSizes"
                  layout="total, sizes, prev, pager, next, jumper" :total="totals"></el-pagination>
              </div>

            </div>
          </el-card>

          <el-dialog title="选择等级" :visible.sync="dialogFormVisible5">
            <el-form>
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-form-item label="请选择等级" :label-width="formLabelWidth">
                <el-select v-model="matchLevel" placeholder="请选择等级">
                  <el-option v-for="item in form" :value="item.levelName" :key="item.id" @click.native="groupId1=item.id">{{item.levelName}}</el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click=" chooselevel()">确 定</el-button>
              <el-button @click="dialogFormVisible5 = false">取 消</el-button>
            </div>
          </el-dialog>

          <el-dialog title="选择增减" :visible.sync="dialogFormVisible6">
            <el-form>
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-form-item label="请选择增减" :label-width="formLabelWidth">
                <el-select v-model="addlevel" placeholder="请选择增减">
                  <el-option label="-2 等级" value="-2"></el-option>
                  <el-option label="-1 等级" value="-1"></el-option>
                  <el-option label="原等级" value="0"></el-option>
                  <el-option label="+1 等级" value="+1"></el-option>
                  <el-option label="+2 等级" value="+2"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addReduceLevel();dialogFormVisible6 = false">确 定</el-button>
              <el-button @click="dialogFormVisible6 = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  data() {
    return {
      dialogVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogTableVisible1: false,
      dialogFormVisible1: false,
      dialogTableVisible2: false,
      dialogFormVisible2: false,
      dialogTableVisible3: false,
      dialogFormVisible3: false,
      dialogFormVisible4: true,
      dialogFormVisible5: false,
      dialogFormVisible6: false,
      dialogFormVisible7: false,
      dialogFormVisible8: false,
      inputrule: '',
      page: '',
      pages: '',
      pagess: '',
      total: 0,
      totals: 0,
      totalss: 0,
      pageSize: 5,
      pageSizes: 5,
      pageSizess: 5,
      currentPage: 1,
      currentPages: 1,
      currentPagess: 1,
      levelid: [],
      groupId: '',
      addlevel: '',
      addlevel1: '',
      form: [],
      form1: [],
      form2: [],
      leaplevel: '',
      form4: [],
      scoreTop: [],
      disabled: '',
      region: '',
      selectLevel: '',
      region1: '',
      bookSeries: '',
      matchLevel: '',
      learnTime: [],
      bookList: [],
      xcxList: [],
      appletList: '',
      xuanzedengji: true,
      xuanzezengjian: true,
      input: '',
      input1: '',
      formLabelWidth: '120px',
      miniid: '',
      newLevel: true,
      groupId1: '',
      id: '',
      ruleId: '',
      ruleId1: '',
      scoreBottom: '',
      scoreTop: '',
    };
  },
  created() {
    this.referXCXList();
  },

  methods: {
    submit() {
      // console.log(34343434);
      this.lookrule();
      this.lookLearnTime();
      this.lookForwordRule();
      // this.referOrganzationList();
    },
    //查询机构列表
    referOrganzationList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/series',
        method: 'GET',
        params: {
          miniid: this.miniid,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        // console.log(res, '查询机构');
        this.bookList = res.data.data;
      });
    },
    //查询小程序列表
    referXCXList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let url = '/edu/exam/readGrade/applets/' + orgid;
      let pro = this.$http({
        url: url,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        // console.log(res.data.data, 'xcx');
        this.xcxList = res.data.data;
        // console.log(this.miniid,"这是迷你id");
      });
    },
    //小程序禁用与打开
    changeDisabled() {
      this.referXCXList();
      this.disabled = false;
    },
    //切换系列
    changeSeries() {
      this.dialogFormVisible4 = true;
    },
    //新建
    readGrade() {
      if (this.inputrule === '') {
        return this.$message.error('不能为空！');
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book',
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          levelCount: this.inputrule,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          // console.log(res, '新增');
          if (res.data.code === 0) {
            this.lookrule();
            return this.$message.success('添加成功！');
          }
        })
        .catch(() => {
          console.log(11123);
        });
    },

    //查看
    lookrule() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book?miniid=' + this.miniid + '&groupId=' + this.groupId + '&pageSize=' + this.pageSize + '&page=' + this.page,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          // console.log(res, '查看');
          if (res.data.code === 0) {
            let data = res.data.data;
            this.form = data;
            this.total = res.data.size;
            if (data == []) {
              // this.addlevel = true;
              // this.newLevel = false;
            }
          }
        })
        .catch(() => {
          console.log(222);
        });
    },
    //删除等级
    removerule(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/' + id + '/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code !== 0) {
          return this.$message.error(res.data.message);
        }
        this.lookrule();
      });
    },
    //新建学习时长
    addLearnTime() {
      let obj = {};
      obj = { learnTimeStr: this.region + 'year' + this.region1 + 'month' };
      this.form1.push(obj);
      this.xuexishichang = Number(this.region) * 12 + Number(this.region1);
      this.xuanzedengji = true;
    },
    //查看时长
    lookLearnTime() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book',
        method: 'GET',
        params: {
          miniid: this.miniid,
          groupId: this.groupId,
          pageSize: this.pageSizess,
          page: this.pagess,
          haveLearnTime: true,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '查看时长');
          if (res.data.code === 0) {
            let data = res.data.data;
            this.form1 = data;
            this.totalss = res.data.size;
            for (let i = 0; i < res.data.data.length; i++) {
              // this.learnTime = parseInt(res.data.data[i].learnTime/12)+'年'+res.data.data[i].learnTime%12+'月';
              if (res.data.data[i].id !== '') {
                this.xuanzedengji = false;
              }
            }
          }
        })
        .catch(() => {
          console.log(222);
        });
    },
    //编辑学习时长
    editLearnTime(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/' + row.id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          if (res.data.code === 0) {
            this.dialogFormVisible7 = true;
            let year = parseInt(res.data.data.learnTime / 12);
            let month = res.data.data.learnTime % 12;
            this.learnTime = year + ' year ' + month + ' month ';
            this.region = year;
            this.region1 = month;
            this.id = row.id;
            console.log(res, '111');
          }
        })
        .catch(() => {
          console.log(222);
        });
    },

    //提交学习时长
    updateTime() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/learnTime/' + this.id + '/upd',
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          learnTime: Number(this.region) * 12 + Number(this.region1),
          learntimeStr: '1 year 2 month',
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, 'aaa');
          if (res.data.code === 0) {
            console.log(this.xuexishichang, '学习时长');
            this.dialogFormVisible7 = false;
            this.lookLearnTime();
            return this.$message.success(res.data.message);
          } else {
            console.log(res);
            return this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          console.log(222);
        });
    },

    //选择等级
    chooselevel() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/' + this.groupId1,
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          learnTime: Number(this.region) * 12 + Number(this.region1),
          learnTimeStr: '1 year 2 month',
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          console.log(res, '等级');
          this.lookLearnTime();
          this.dialogFormVisible5 = false;
          return this.$message.success(res.data.message);
          // this.xuanzedengji = false;
        } else {
          return this.$message.error(res.data.message);
        }
      });
    },
    //修改等级
    changeTimeLevel(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/' + row.id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          if (res.data.code === 0) {
            this.matchLevel = res.data.data.levelName;
            this.id = row.id;
            this.dialogFormVisible5 = true;
            console.log(res, '111');
          }
        })
        .catch(() => {
          console.log(222);
        });
    },
    //提交等级
    submitLevel() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/level/upd',
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          sourceId: this.id,
          targetId: this.groupId1,
          learnTime: 16,
          learnTimeStr: '11month',
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          console.log(res, '等级');
          this.lookLearnTime();
          this.dialogFormVisible5 = false;
          return this.$message.success(res.data.message);
        } else {
          return this.$message.error(res.data.message);
        }
      });
    },
    //删除学习时长
    deleteTime(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/learnTime/' + id,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        // console.log(res, '诶嘿');
        this.lookLearnTime();
        return this.$message.success('删除成功！');
      });
    },
    //新建测试规则
    addTestRule() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule',
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          scoreBottom: this.input,
          scoreTop: this.input1,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          if (res.data.code === 0) {
            console.log(res.data, '新建进阶');
            let obj = {};
            obj = { scoreTop: this.input + '——' + this.input1 };
            this.form4.push(obj);
            this.ruleId = res.data.data.ruleId;
            this.lookForwordRule();
            return this.$message.success(res.data.message);
          } else {
            return this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          console.log(222);
        });
    },
    //查看进阶规则
    lookForwordRule() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule?miniid=' + this.miniid + '&groupId=' + this.groupId + '&pageSize=' + this.pageSizes + '&page=' + this.pages,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '查看11');
          this.form4 = res.data.data;
          this.totals = res.data.size;
        })
        .catch(() => {
          console.log(222);
        });
    },
    //根据id查进阶规则
    lookThisRule(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule/' + id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '查看121');
          this.addlevel = res.data.data.ruleStr;
          this.dialogFormVisible6 = true;
          this.ruleId = id;
        })
        .catch(() => {
          console.log(222);
        });
    },
    //增减等级
    addReduceLevel() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule/' + this.ruleId,
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          scoreBottom: this.input,
          scoreTop: this.input1,
          ruleInt: this.addlevel,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '编辑进阶规则');
          console.log(this.addlevel, '编辑进阶规则1');
          this.dialogFormVisible6 = false;
          this.input = this.scoreBottom;
          this.input1 = this.scoreTop;
          this.addlevel1 = this.addlevel + '等级';
          this.lookForwordRule();
        })
        .catch((res) => {
          console.log(res, 'sss');
        });
    },
    //查看编辑的分
    lookEdiltRule(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule/' + id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '查看121');
          this.scoreTop = res.data.data.scoreTop;
          this.scoreBottom = res.data.data.scoreBottom;
          this.dialogFormVisible8 = true;
          this.ruleId1 = id;
        })
        .catch(() => {
          console.log(222);
        });
    },
    //编辑得分
    editForwordrule() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule/' + this.ruleId,
        method: 'POST',
        data: {
          miniid: this.miniid,
          groupId: this.groupId,
          scoreBottom: this.input,
          scoreTop: this.input1,
          ruleInt: Number(this.addlevel),
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '编辑进阶规则q');
          if (res.data.code === 0) {
            this.lookForwordRule();
          }
        })
        .catch(() => {
          console.log('222q');
        });
    },
    //删除进阶规则
    deleteForword(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/rule/' + id + '/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '诶嘿');
          this.lookForwordRule();
          return this.$message.success('删除成功！');
        })
        .catch((res) => {
          console.log(res, '222q');
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.lookrule();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.lookrule();
    },
    handleSizeChanges(val) {
      this.pageSizes = val;
      this.pages = 1;
      this.currentPages = 1;
      this.lookForwordRule();
    },

    handleCurrentChanges(val) {
      this.pages = val;
      this.lookForwordRule();
    },
    handleSizeChangess(val) {
      this.pageSizess = val;
      this.pagess = 2;
      this.currentPagess = 1;
      this.lookLearnTime();
    },

    handleCurrentChangess(val) {
      this.pagess = val;
      this.lookLearnTime();
    },
  },
};
</script>
s
<style lang="less">
.rule {
  position: relative;
  margin-top: -20px;
  .xiaoqu_1 {
    font-weight: Bold;
  }

  .xiaoqu_2 {
    position: absolute;
    font-weight: 600;
    font-size: 18px;
    top: 3px;
    right: 0;
    .icon_change {
      position: absolute;
      width: 22px;
      height: 22px;
      right: 77px;
      border-radius: 50%;
      padding: 0;
      background: url('../../../assets/img/home/qiehuan_1.png') #00a6e6 no-repeat center;
      background-size: 0.85vw;
    }
  }
}
</style>
<style>
.scroeStart {
  display: inline-block;
  width: 12.5rem /* 200/16 */;
}
.scroeEnd {
  display: inline-block;
  width: 12.5rem /* 200/16 */;
}
.hint {
  display: inline-block;
  color: #f66200;
  font-size: 0.875rem /* 14/16 */;
  margin-left: 1.25rem /* 20/16 */;
}
.bottom-card {
  display: flex;
  margin-top: 21px;
}
.bottom-card-left {
  position: relative;
  padding-right: 7px;
}
.bottom-card-right {
  position: relative;
  padding-left: 7px;
}
.btn-hint {
  display: flex;
}
.el-form i {
  position: absolute;
  top: 10px;
  left: 30px;
}
.tableHeader {
  height: 0;
}
.zsbg {
  position: relative;
}

.zsbg_table2 {
  margin-top: -65px;
}
.el-card__body {
  position: relative;
}
.fenye,
.fenye-bottom_right,
.fenye-bottom_left {
  position: absolute;
  right: 10px;
  bottom: 50px;
}
</style>
